{
  "version": 1,
  "asset_id": "a047089d-0703-4767-bd24-97266ec2ab7a",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/a047089d-0703-4767-bd24-97266ec2ab7a/hanna-gruzdowska.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/a047089d-0703-4767-bd24-97266ec2ab7a/hanna-gruzdowska.jpg",
  "original_filename": "hanna-gruzdowska.jpg",
  "size": 92791,
  "content_type": "image/jpeg",
  "created_at": "2026-09-21T10:43:40Z"
}
